/**
 * External dependencies.
 */
 import React, {PropsWithChildren} from 'react';
 import cx from 'classnames';
 
 const Button = ({ className, disabled, children,onClick }: PropsWithChildren<{ className?: string, disabled?: boolean,onClick?:any }>) => {
     return (
         <button disabled={disabled} className={cx('btn', className)} onClick={onClick}>{children}</button>
     );
 };
 
 export default Button;
 